import React from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px;
  margin-top: 16px;
`;

const PageBtn = styled.button`
  min-width: 32px;
  height: 32px;
  border: 1px solid ${(p) => (p.$active ? '#667eea' : '#d1d5db')};
  background: ${(p) => (p.$active ? '#667eea' : '#fff')};
  color: ${(p) => (p.$active ? '#fff' : '#374151')};
  border-radius: 6px;
  font-size: 13px;
  cursor: pointer;
  &:hover { background: ${(p) => (p.$active ? '#5a6fd6' : '#f3f4f6')}; }
  &:disabled { opacity: 0.4; cursor: default; }
`;

export default function Pagination({ page, totalPages, onChange }) {
  if (totalPages <= 1) return null;

  const pages = [];
  const start = Math.max(1, page - 2);
  const end = Math.min(totalPages, page + 2);
  for (let i = start; i <= end; i++) pages.push(i);

  return (
    <Wrapper>
      <PageBtn disabled={page <= 1} onClick={() => onChange(page - 1)}>&lt;</PageBtn>
      {start > 1 && <><PageBtn onClick={() => onChange(1)}>1</PageBtn><span>...</span></>}
      {pages.map((p) => (
        <PageBtn key={p} $active={p === page} onClick={() => onChange(p)}>{p}</PageBtn>
      ))}
      {end < totalPages && <><span>...</span><PageBtn onClick={() => onChange(totalPages)}>{totalPages}</PageBtn></>}
      <PageBtn disabled={page >= totalPages} onClick={() => onChange(page + 1)}>&gt;</PageBtn>
    </Wrapper>
  );
}
